import React from "react";
import { Helmet } from "react-helmet";
import Familia from "../images/familia.png";
import Fam1 from "../images/fam1.png";
import Fam2 from "../images/fam2.png";
import Fam3 from "../images/fam3.png";
import Fam4 from "../images/fam4.png";
import Fam5 from "../images/fam5.png";
import Habito1 from "../images/habito1.png";
import Habito2 from "../images/habito2.png";
import Habito3 from "../images/habito3.png";
import FondoTablon from "../images/fondotablon.png";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
    },
    "& p": {
      lineHeight: 1.5,
    },
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoTablon + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "auto",
    width: "100%",
    marginTop: 40,
    paddingLeft: 5,
    paddingBottom: 40,
    paddingTop: 20,
    "& p": {
      lineHeight: 1.5,
      maxWidth: "90%",
      margin: "0 auto",
    },
    marginBottom: "4em",
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "6%",
    },
  },
  actividad: {
    background: "rgba(255, 213, 55, 0.25)",
    border: "6px solid " + theme.palette.secondary.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  root: {
    textAlign: "center",
  },
}));

const Lamina1 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa: Lámina 1: La familia"
        meta={[
          {
            property: "og:title",
            content: "Lámina 1: La familia",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "La familia es un tema es muy importante a tratar en la escuela porque es en donde aprendemos a relacionarnos positivamente con las personas.",
            dataReactHelmet: true,
          },
        ]}
      />

      <Banner number="1" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid container spacing={0} alignItems="center" justify="center">
          <Grid item lg={6} md={6} xs={12}>
            <Title title="La familia" color="primary" />
            <p>
              Todas las personas tenemos una familia de la cual formamos parte.
              Por lo general, la familia está formada por personas que viven
              juntas, quienes se encuentran unidas por lazos de parentesco y
              afecto.
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Familia} alt="Familia" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>
            Observa las imágenes. Luego, dialoga con alguna persona en casa y
            responde estas preguntas:
          </strong>
        </p>
        <ul>
          <li>¿Cómo están conformadas las familias de las imágenes?</li>
          <li>¿En qué se parecen y en qué se diferencian?</li>
        </ul>
        <div className={classes.actividadFondo}>
          <Grid
            container
            spacing={1}
            alignItems="center"
            justify="center"
            className={classes.root}
          >
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <img src={Fam1} alt="Familia" />
            </Grid>
            <Grid item lg={5} md={5} sm={6} xs={12}>
              <img src={Fam2} alt="Familia" />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <img src={Fam3} alt="Familia" />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <img src={Fam4} alt="Familia" />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <img src={Fam5} alt="Familia" />
            </Grid>
            <Grid item lg={12} xs={12}>
              <p>
                Las familias pueden ser muy diferentes. Las hay numerosas, que
                están integradas por papá, mamá, abuela, abuelo, tías, tíos,
                primas, primos... Y las hay pequeñas, a veces solo con una
                persona adulta, que acompaña y educa a un hijo o una hija.
                Además, las familias cambian con el tiempo.
              </p>
            </Grid>
          </Grid>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="EXISTEN MUCHOS TIPOS DE FAMILIA" color="primary" />
        <Grid container spacing={2} alignItems="center" justify="center">
          <Grid item lg={12} xs={12}>
            <p>
              Todas las familias son únicas e igual de valiosas. Y todas las
              personas que las integran también son importantes por sus
              historias de vida, por sus costumbres y tradiciones, etc.
            </p>
          </Grid>
          <Grid item lg={12} xs={12}>
            <div className={classes.actividad}>
              <Actividad color="primary" />
              <p>
                <strong>¿Y cómo es tu familia? Responde:</strong>
              </p>
              <ul>
                <li>¿Quiénes la conforman?</li>
                <li>¿Cuántas personas son?</li>
                <li>¿Cuántos adultos hay en tu familia?</li>
                <li>Dibuja a tu familia y escribe sus nombres.</li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="NUEVOS HÁBITOS DE CONVIVENCIA" color="primary" />
        <p>
          Recuerda que, para protegernos, proteger a los miembros de nuestra
          familia y, en general, a las personas que nos rodean, todos debemos
          ser muy cuidadosos y practicar nuevos hábitos.
        </p>
        <Grid container className={classes.root} spacing={2} justify="center">
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Habito1} alt="Nuevos habitos" />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Habito2} alt="Nuevos habitos" />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Habito3} alt="Nuevos habitos" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-1.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 1: La familia'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        siguiente="Deberes y rutinas en casa"
        siguienteEnlace="/lamina-1-2"
      />
    </>
  );
};

export default Lamina1;
